<!-- class="hogehoge" → styleで.hogehogeでスタイル指定できる -->
<template>
  <div>
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        新しいパスワードをご入力ください
        <div class="headerBtn" @click="screenTransition()" style="margin: 0px 0px 0px 20px;">ログイン画面に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="putLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 更新エラー表示 -->
      <div v-if="putErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{ errorMessage }}
          </div>
        </div>
      </div>
      <div v-if="!passwordChangeFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div class="errSpan" style="font-size:x-large;">
          ご入力のメールアドレス宛に送信された確認コードと新しいパスワードをご入力下さい。
        </div>
      </div>
      <!-- 変更済み表示 -->
      <div v-if="passwordChangeFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div class="errSpan" style="font-size:x-large;">
          ログインパスワードの変更が完了致しました。ログイン画面に戻り、ログインをご確認下さい。
        </div>
      </div>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <p class="inputTitle">確認コード</p>
          <validation-provider name="確認コード" rules="required|numeric|min:6|max:6" mode="lazy">
            <div slot-scope="ProviderProps">
              <input  class="text small" v-model="code">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
          <p class="inputTitle">新しいパスワード</p>
          <div class="inputTitle">*最小桁数8桁</div>
          <validation-provider name="新しいパスワード" rules="required|min:8|max:64|password" vid="confirmation" mode="lazy">
            <div slot-scope="ProviderProps">
              <input type="password" class="text small" v-model="newPassword">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
          <p class="inputTitle">新しいパスワードの再入力</p>
          <validation-provider name="新しいパスワードの再入力" rules="required|confirmed:confirmation|min:8|max:64|password" mode="lazy">
            <div slot-scope="ProviderProps">
              <input type="password" class="text small" v-model="newPasswordConfirm">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
          <div class="buttonGroup">
            <button class="btn" type="button" @click="confirm" v-if="!passwordChangeFlg"
              v-bind:class="{ disabled: ObserverProps.invalid || !ObserverProps.validate,
              active: !ObserverProps.invalid && ObserverProps.validate}"
              :disabled="ObserverProps.invalid || !ObserverProps.validated">変更
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>

</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, max, min, confirmed, regex, numeric } from 'vee-validate/dist/rules';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import CognitoMessages from "../cognito/cognitoMessages";

export default {
  title: 'パスワード再発行',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  props: {
    loginId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      code: '',
      newPassword: '',
      newPasswordConfirm: '',
      errorMessage: '',
      // ローディング
      putLodingFlg: false,  // データ更新時ローディングフラグ
      putErrorFlg: false,   // データ更新時エラーフラグ
      passwordChangeFlg: false, // パスワード変更済みフラグ
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    // 変更ボタン押下時処理
    async confirm() {
      try {
        this.putErrorFlg = false;
        this.putLodingFlg = true;
        // パスワード変更処理呼び出し
        await this.$cognito.resetPassword(this.loginId, this.newPassword, this.code);
        this.passwordChangeFlg = true;
      } catch (error) {
        this.errorMessage = await CognitoMessages.translateMessage(error.code);
        // TODO suzuno エラー横串時に共通cognitoエラーメッセージ返却関数に変更
        // switch (error.code) {
        //   case 'CodeMismatchException':
        //     this.errorMessage = '検証コードが正しくありません。メール内の検証コードを改めてご確認下さい';
        //     break;
        //   case 'LimitExceededException':
        //     this.errorMessage = '検証コードを複数回誤りました。時間を空けて再度ご入力下さい';
        //     break;
        //   case 'ExpiredCodeException':
        //     this.errorMessage = '検証コードの有効期限が切れています。ログイン画面からやり直して下さい';
        //     break;
        //   default:
        //     break;
        // }
        this.putErrorFlg = true;
      } finally {
        this.putLodingFlg = false;
      }
    },
    // ログイン画面へ遷移
    screenTransition() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/variables.scss";

</style>
